import React from 'react';
import { flexRender, Table } from '@tanstack/react-table';

type Props = {
	table: Table<unknown>;
	handleRowClick?: (row: any) => void;
};
const TableBody = ({ table, handleRowClick }: Props) => {
	return (
		<tbody>
			{table.getRowModel().rows.map((row) => (
				<tr
					key={row.id}
					{...(handleRowClick
						? {
								className: 'cursor-pointer',
								onClick: () => handleRowClick(row.original),
							}
						: {})}>
					{row.getVisibleCells().map((cell) => (
						<td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
					))}
				</tr>
			))}
		</tbody>
	);
};

export default TableBody;
